export default __webpack_public_path__ + "static/media/ar-1yearfree.6442fb7a.svg";